__turbopack_context__.v({
  "h1": "chXROq_h1",
  "h2": "chXROq_h2",
  "h3": "chXROq_h3",
  "h4": "chXROq_h4",
  "pullQuote": "chXROq_pullQuote",
  "pullQuoteLong": "chXROq_pullQuoteLong",
  "quote": "chXROq_quote",
});
